import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@storable/canaveral-components';

const propTypes = {
  innerText: PropTypes.string,
  submitting: PropTypes.bool,
};

const defaultProps = {
  innerText: undefined,
  submitting: undefined,
};

const FormSubmitButton = ({
  innerText,
  submitting,
  ...rest
}) => {
  let text = innerText;
  if (!text) {
    text = submitting ? 'Saving...' : 'Save';
  }

  return (
    <Button
      type="submit"
      {...rest}
      context="positive"
      loading={submitting}
    >
      {text}
    </Button>
  );
};

FormSubmitButton.propTypes = propTypes;
FormSubmitButton.defaultProps = defaultProps;

export default FormSubmitButton;
